import { Theme } from 'config';

const styles = (theme: Theme) => ({
  MUGModalButton: {
    backgroundColor: theme.violet,
    borderRadius: '1.5rem',
    border: 'none',
    color: '#fff',
    fontSize: '1rem',
    fontWeight: '500',
    marginTop: '1rem',
    padding: '0.5rem 1.25rem',
    lineHeight: '1.25rem',
    cursor: 'pointer',
  },
});

export default styles;
